// Same as Playground and Observer.
// Same as: https://developers.cloudflare.com/automatic-platform-optimization/reference/cache-device-type/
// eslint-disable-next-line max-len
const MOBILE_REGEX = /(?:phone|windows\s+phone|ipod|blackberry|(?:android|bb\d+|meego|silk|googlebot) .+? mobile|palm|windows\s+ce|opera mini|avantgo|mobilesafari|docomo|kaios)/i;
const TABLET_REGEX = /(?:ipad|playbook|android|bb\d+|meego|silk)/i;
const TABLET_NOT_REGEX = /(?:android|bb\d+|meego|silk) .+? mobile/i;

function isIPadOS() {
    if (typeof navigator === 'undefined') {
        return false;
    }

    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

function getDeviceCategory(userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent) {
    if (isIPadOS()) return 'tablet';
    if (MOBILE_REGEX.test(userAgent)) return 'mobile';
    if (TABLET_REGEX.test(userAgent) && !TABLET_NOT_REGEX.test(userAgent)) return 'tablet';
    return 'desktop';
}

const deviceCategory = getDeviceCategory();

export const isMobile = deviceCategory === 'mobile';
export const isTablet = deviceCategory === 'tablet';
export const isDesktop = deviceCategory === 'desktop';
